export function SetWithExpiry(key, value, ttl) {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}
export function GetWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export function GetSerialProgram() {
  const SP = localStorage.getItem("serial_program");
  if (isNaN(SP)) {
    window.location.replace("/authenticate/signUp");
    return(false);
  }else{
    return(SP);
  }
}

export function ExitSoftware() {
  localStorage.removeItem("user");
  localStorage.removeItem("serial_program");
  localStorage.clear();
  window.location.replace("/authenticate/signUp");
}
